import { render, staticRenderFns } from "./activitytemplate-add-or-update.vue?vue&type=template&id=56f77a1a&scoped=true&"
import script from "./activitytemplate-add-or-update.vue?vue&type=script&lang=js&"
export * from "./activitytemplate-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./activitytemplate-add-or-update.vue?vue&type=style&index=0&id=56f77a1a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f77a1a",
  null
  
)

export default component.exports